import { render, staticRenderFns } from "./page_tabs.vue?vue&type=template&id=75a87301"
import script from "./page_tabs.vue?vue&type=script&lang=js"
export * from "./page_tabs.vue?vue&type=script&lang=js"
import style0 from "./page_tabs.vue?vue&type=style&index=0&id=75a87301&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports